import { render, staticRenderFns } from "./veStuGraduationAuditInfoShow.vue?vue&type=template&id=868b348e&scoped=true"
import script from "./veStuGraduationAuditInfoShow.vue?vue&type=script&lang=js"
export * from "./veStuGraduationAuditInfoShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "868b348e",
  null
  
)

export default component.exports